<template>
	<div class="profile-menstruation">
		<!-- ローディング -->
		<transition name="fade">
			<redraw-progress v-if="isLoading" />
		</transition>
		<!-- /ローディング -->
		<div class="profile-menstruation__contents--list">
			<!-- TODO: 生理日一覧部分は今後必要に応じてコンポーネント化を検討 -->
			<div class="profile-menstruation-history">
				<div class="profile-menstruation-history__heading">
					<span class="profile-menstruation-history__heading--history">履歴</span>
					<span class="profile-menstruation-history__heading--period">期間</span>
					<span class="profile-menstruation-history__heading--cycle">周期</span>
				</div>
				<div class="profile-menstruation-history__contents">
					<ul class="profile-menstruation-history__contents--list">
						<li v-for="(menstruationDataItem, index) in menstruationDataList" class="profile-menstruation-history__contents--item" :key="index">
							<a :href="menstruationDataItem.from_time ? `native://openGraph?at=${menstruationDataItem.from_time}` : 'javascript:void(0)'" class="profile-menstruation-history__contents--anchor">
								<span class="profile-menstruation-history__contents--anchor-history"><i class="profile-menstruation-history__contents--anchor-start sprite-menstruation profile_start" />{{ menstruationDataItem.history_date }}</span>
								<span class="profile-menstruation-history__contents--anchor-period">{{ menstruationDataItem.term }}</span>
								<span class="profile-menstruation-history__contents--anchor-cycle">{{ menstruationDataItem.cycle }}</span>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_PAININPERIOD_DATA } from '../../store/modules/painNote/mutation-types'
import { SET_MENSTRUATION_DATA } from '../../store/modules/menstruation/mutation-types'

// Compornents
import RedrawProgress from '../../components/Molecules/RedrawProgress'

// ライブラリ
import moment from 'moment'
moment.locale('ja')

export default {
	name: 'ProfileMenstruationList',
	components: {
		RedrawProgress
	},
	data () {
		return {
			painFirstData: null,
			menstruationDataList: null,
			isLoading: false
		}
	},
	mounted () {
		this.getPainperiodData()
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userId', 'userToken', 'userData', 'premiumType']),
		...mapGetters('painNote', ['painInperiodData']),
		...mapGetters('menstruation', ['menstruationData'])
	},

	methods: {
		// map Vuex actions
		...mapActions('painNote', [SET_PAININPERIOD_DATA]),
		...mapActions('menstruation', [SET_MENSTRUATION_DATA]),

		/**
		 * 痛み記録データ取得(期間)処理
		 */
		getPainperiodData () {
			// HACK: 痛み記録を生理日記録の開始日指定のためだけに取得しているっぽいので大規模改修のタイミングでリファクタリングしたい。
			// HACK: パフォーマンスを気にして「記録可能な最も古い期間」から「ユーザー登録日」の痛み記録をとって生理記録の検索開始日時にしているが、そもそも痛み記録をとらなくても生理記録の検索開始日時を「記録可能な最も古い期間」にしても良さそう（月1記録があるとして10年でも120レコードなのでパフォーマンス的にも悪くなさそう）。
			// NOTE: ユーザー登録後、過去にさかのぼって記録をつけたケースに対応するため、ユーザー登録日の前に痛み記録が存在するかのチェック
			// TODO: 記録可能な最も古い期間が何故2015/12/1なのかの根拠について要調査
			const firstDate = 1448895600	// NOTE: 記録可能な最も古い期間（2015-12-01 00:00:00）
			const insertDate = this.userData.insert_date.sec // NOTE: ユーザの登録日
			const includeRiseWarning = 1 // NOTE: 気圧アラート取得のフラグを立てる, webviewのため1

			if (firstDate < insertDate) {	// 「記録可能な最も古い期間」のあとにユーザーが登録しているケース
				this.SET_PAININPERIOD_DATA({
					user_id: this.userId,
					user_token: this.userToken,
					from: firstDate,
					to: insertDate,
					include_rise_warning: includeRiseWarning
				}).then(res => {
					this.painFirstData = this.painInperiodData.records.map(item => {
						return {
							'date': item.hour.sec
						}
					}).slice(0, 1)[0]

					this.getMenstruationData()
				}).catch(error => {
					console.log(error)
					// NOTE: エラーが起こった場合、登録日の前に痛み記録はないと見なして登録日を基点に生理記録を取得する
					this.getMenstruationData()
				})
			} else {	// 「記録可能な最も古い期間」以前にユーザーが登録しているケース
				// NOTE: このケースでAPIにリクエストするとエラーになりcatchに入るためなくても動作するが、リクエストを減らす意味で実装しています
				this.getMenstruationData()
			}
		},

		/**
		 * 記録データ取得(件数)処理
		 */
		getMenstruationData () {
			// HACK: このメソッドの処理が煩雑すぎるので大規模改修のタイミングでリファクタリングしたい。
			this.isLoading = true
			const insertDate = this.painFirstData ? this.painFirstData.date : this.userData.insert_date.sec // NOTE: 最初の痛み記録 or ユーザの登録日
			const endOfThisMonth = moment().add(1, 'months').endOf('month').unix() // NOTE: 来月末（「生理開始日+期間の日付」が来月にまたぐことがあるため）
			// プレミアムユーザーフラグ
			const isPremium = this.premiumType && this.premiumType.premium_type_code > 1

			this.SET_MENSTRUATION_DATA({
				user_id: this.userId,
				user_token: this.userToken,
				from: insertDate,
				to: endOfThisMonth
			}).then(res => {
				const menstruationDataList = this.menstruationData.records.map((item, index, array) => {
					return {
						'from_time': item.from_time.sec,
						'history_date': moment.unix(item.from_time.sec).format('YYYY年M月D日（ddd）～'),
						'term': `${moment.unix(item.term).diff(0, 'days')}日`,
						'cycle': index !== 0 ? `${moment.unix(array[index].from_time.sec).diff(moment.unix(array[index - 1].from_time.sec), 'days')}日` : '-',
						'is_expected': item.is_expected
					}
				}).filter(item => {
					// NOTE: 生理日記録の無料開放対応で痛み記録がない場合、無料ユーザーはユーザの登録日ではなく90日以前を基点に取得するよう変更（無料ユーザーは90日以前の気圧グラフに遷移できないため）。
					if (!isPremium) {
						return !item.is_expected && item.from_time >= moment().add(-90, 'days').unix()
					} else {
						return !item.is_expected
					}
				}).reverse()

				this.menstruationDataList = menstruationDataList
			}).catch(error => {
				// TODO: エラー処理
				console.log(error)
			}).finally(() => {
				this.isLoading = false
			})
		}
	}
}
</script>
